/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<2655033069c41c94a8867c7f6b2885a7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type requestFormsFragment$data = {
  readonly requestForms: ReadonlyArray<{
    readonly __typename: "HelpObjectStoreSearchResult";
    readonly containerDisplayName?: string | null | undefined;
    readonly description?: string;
    readonly displayLink?: string;
    readonly id?: string;
    readonly isExternal?: boolean;
    readonly message?: string | null | undefined;
    readonly title?: string;
    readonly " $fragmentSpreads": FragmentRefs<"resourceIconFragment">;
  } | null | undefined>;
  readonly " $fragmentType": "requestFormsFragment";
};
export type requestFormsFragment$key = {
  readonly " $data"?: requestFormsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"requestFormsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "portalIds"
    },
    {
      "kind": "RootArgument",
      "name": "queryTerm"
    },
    {
      "kind": "RootArgument",
      "name": "resultLimit"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "requestFormsFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "requestForms",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "entityType",
                "value": "REQUEST_FORM"
              },
              {
                "kind": "Variable",
                "name": "portalIds",
                "variableName": "portalIds"
              },
              {
                "kind": "Variable",
                "name": "queryTerm",
                "variableName": "queryTerm"
              },
              {
                "kind": "Variable",
                "name": "resultLimit",
                "variableName": "resultLimit"
              }
            ],
            "kind": "ObjectValue",
            "name": "searchInput"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "searchHelpObjects",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                "action": "THROW",
                "path": "requestForms.__typename"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                "action": "THROW",
                "path": "requestForms.id"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                "action": "THROW",
                "path": "requestForms.title"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                "action": "THROW",
                "path": "requestForms.description"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayLink",
                  "storageKey": null
                },
                "action": "THROW",
                "path": "requestForms.displayLink"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "containerDisplayName",
                "storageKey": null
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isExternal",
                  "storageKey": null
                },
                "action": "THROW",
                "path": "requestForms.isExternal"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "resourceIconFragment"
              }
            ],
            "type": "HelpObjectStoreSearchResult",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "HelpObjectStoreQueryError",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW",
      "path": "requestForms"
    }
  ],
  "type": "HelpObjectStoreQueryApi",
  "abstractKey": null
};

(node as any).hash = "09dee394e99ef5074a982771cb245242";

export default node;
